import { QueryClient } from '@tanstack/react-query';

// Shared so code outside React (e.g. sign-out) can clear cached data.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 0,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
});

// The signed-in admin's profile; cached for the whole session (Admin Portal performance task)
export const PROFILE_QUERY_KEY = ['fetchProfile'];
